import {
  IonContent,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  SegmentChangeEventDetail,
  useIonViewWillEnter,
} from '@ionic/react'
import { StyleIonHeader } from '../../../components'
import { useContext, useState } from 'react'
import { MainNotice } from './MainNotice'
import { MainNotification } from './MainNotification'
import { MainSell } from './MainSell'
import { StoresContext } from '../../../provider/StoreProvider'
import { LIST_TYPE_NOTIFICATION } from '../../../common'

interface IonSegmentCustomEvent<T> extends CustomEvent<T> {
  detail: T
  target: HTMLIonSegmentElement
}

export const Main: React.FC = () => {
  const { commonStore } = useContext(StoresContext)

  const [listType, setListType] = useState<LIST_TYPE_NOTIFICATION>(LIST_TYPE_NOTIFICATION.NOTICE)

  useIonViewWillEnter(() => {
    commonStore.setShowTab(true)
  })

  const onSegmentChange = (e: IonSegmentCustomEvent<SegmentChangeEventDetail>) => {
    if (e.target.value !== 'NOTICE' && e.target.value !== 'NOTIFICATION' && e.target.value !== 'SELL') {
      return
    }
    setListType(LIST_TYPE_NOTIFICATION[e.target.value])
  }

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'공지 / 알림'} href={'/home'} />
      <IonContent>
        <IonSegment color="dark" value={listType} onIonChange={(e) => onSegmentChange(e)}>
          <IonSegmentButton value="NOTICE">
            <IonLabel>공지</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="NOTIFICATION">
            <IonLabel>알림</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="SELL">
            <IonLabel>매각</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        {listType === LIST_TYPE_NOTIFICATION.NOTICE && <MainNotice />}
        {listType === LIST_TYPE_NOTIFICATION.NOTIFICATION && <MainNotification />}
        {listType === LIST_TYPE_NOTIFICATION.SELL && <MainSell />}
      </IonContent>
    </IonPage>
  )
}
